<template>
    <div
        :class="{
            'sm:border-t sm:border-gray-200 sm:py-5' : withBorder,
            'space-y-1 sm:space-y-0 sm:grid sm:grid-cols-3 sm:gap-4': isInline
        }"
    >

        <label v-if="label" :for="id"
               :class="{
                   'block text-sm font-bold text-gray-900': true,
                   'mb-2': !isInline,
                   'sm:mt-px sm:pt-2': isInline
                }"
        >
            {{ label }} {{ required ? '*' : '' }}
        </label>

        <div :class="isInline ? 'sm:col-span-2 relative' : 'w-full'" class="flex flex-col">
            <div :class="mode === 'avatar' ? 'w-48 m-auto' : 'w-full'">
                <FilePond
                    :id="id"
                    :name="name"
                    ref="pond"
                    class-name="vue-filepond"
                    :server="options.server"
                    :allow-multiple="multiple && mode !== 'avatar'"
                    :allowFileTypeValidation="withValidation"
                    :accepted-file-types="acceptedFileTypes"
                    v-bind="options[mode]"
                    :files="files"
                    :chunkUploads="chunkUploads"
                    :chunkSize="chunkSize"
                    :beforeAddFile="beforeAddFile"
                    @addfilestart="handleStartUpload"
                    @processfiles="handleEndUpload"
                    @removefile="handleRemoveFile"
                />
            </div>

            <div v-if="tooltip || errors && errors.length > 0" class="flex flex-col justify-between mt-2">
                <p v-if="errors && errors.length > 0" v-for="error in errors"
                   class="text-red-500 text-xs italic mb-1 mt-1">{{ error }}</p>
                <p v-if="tooltip" class="text-sm text-gray-500">{{ tooltip }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import vueFilePond from 'vue-filepond';

    import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
    import FilePondPluginImagePreview from "filepond-plugin-image-preview";

    import "filepond/dist/filepond.min.css";
    import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

    const FilePond = vueFilePond( FilePondPluginFileValidateType, FilePondPluginImagePreview );

    export default {
        props: {
            id: String,
            name: String,
            label: String,
            labelIdle: String,
            multiple: Boolean,
            withValidation: Boolean,
            acceptedFileTypes: String,
            tooltip: String,
            errors: Array,
            withBorder: Boolean,
            isInline: Boolean,
            required: Boolean,
            mode: {
                type: String,
                default: 'classic'
            },
            currentUrl: String,
            chunkUploads: Boolean,
            chunkSize: {
                type: Number,
                default: 1000000
            },
            // FilePond hook: resolving false drops the file before any upload starts.
            beforeAddFile: Function,
            modelValue: [String, Array],
        },
        beforeMount() {
            this.$store.dispatch('upload/resetSingle')
        },
        data() {
            return {
                files: [],
                options: {
                    server: {
                        url: '/api/filepond',
                        headers: {
                           // 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').attributes.content.value
                            'X-XSRF-TOKEN': $cookies.get('XSRF-TOKEN')
                        },
                    },
                    avatar: {
                        labelIdle: this.currentUrl
                            ? '<div class="absolute inset-0 h-full w-full">Drag & Drop your avatar or <span class="filepond--label-action">Browse</span></div><img alt="avatar" src="'+this.currentUrl+'" class="absolute top-0 left-0 bg-white p-4"/>'
                            : 'Drag & Drop your file or <span class="filepond--label-action">Browse</span>',
                        imagePreviewHeight: "170",
                        imageCropAspectRatio: "1:1",
                        imageResizeTargetWidth: "200",
                        imageResizeTargetHeight: "200",
                        stylePanelLayout: "compact circle",
                        styleLoadIndicatorPosition: "center bottom",
                        styleProgressIndicatorPosition: "right bottom",
                        styleButtonRemoveItemPosition: "left bottom",
                        styleButtonProcessItemPosition: "right bottom",
                        imageResizeMode: 'cover'
                    },
                    classic: {
                        labelIdle: this.currentUrl
                            ? '<div class="absolute inset-0 h-full w-full overflow-hidden">Drag & Drop your avatar or <span class="filepond--label-action">Browse</span><img alt="picture" src="'+this.currentUrl+'" class="absolute w-full h-full object-cover top-0 left-0"/></div>'
                            : 'Drag & Drop your file or <span class="filepond--label-action">Browse</span>',
                    }
                }
            }
        },
        methods: {
            handleProcess(fieldName, file, metadata, load, error, progress, abort, transfer, options) {
                this.$store.dispatch('upload/process', { name: this.name, fieldName, file, metadata, load, error, progress, abort, transfer, options });
            },
            handleRevert(path, load) {
                this.$store.dispatch('upload/revert', {path, name: this.name, load});
            },
            handleStartUpload() {
                this.$emit('startLoad', this.$refs.pond.getFiles());
            },
            handleEndUpload() {
                this.$emit('endLoad', this.$refs.pond.getFiles());
            },
            handleRemoveFile() {
                this.$emit('endLoad', this.$refs.pond.getFiles());
            }
        },
        components: {
            FilePond,
        }
    }
</script>
